/* qeslint-disable */
// q@ts-nocheck

import { Cartesian3, DeveloperError, Viewer } from "cesium";
import { MouseButton, MouseEvent, MapTool } from "../core";
import { EditablePolyline } from "./annotation/EditablePolyline";

const cart3Scratch = new Cartesian3();

export class PolylineEditTool extends MapTool {
    private _polyline: EditablePolyline | undefined;
    private _selectedPrimitive: any;
    private _nearestVertexIndex: number = -1;
    private _nearestEdgeIndex: number = -1;

    constructor(options: { viewer: Viewer }) {
        super({
            name: "PolylineEditTool",
            viewer: options.viewer
        });
    }

    get polyline() {
        if (!this._polyline) {
            throw new DeveloperError("error");
        }

        return this._polyline;
    }

    activate(activateOptions: { polyline: EditablePolyline }): void {
        super.activate(activateOptions);

        this._polyline = activateOptions.polyline;

        this._polyline.startEditing();
    }

    deactivate(deactivateOptions: { normallyDeactivate: boolean }): void {
        super.deactivate(deactivateOptions);

        if (deactivateOptions && deactivateOptions.normallyDeactivate) {
            this.polyline.restoreMainVertices();
            this.polyline.removeMiddleVertices();
        } else {
            this.polyline.cancelEditing();
        }

        this._polyline = undefined;
    }

    canvasPressEvent(/* event: MouseEvent */): void {
        if (this._nearestVertexIndex === -1 && this._nearestEdgeIndex === -1) {
            this._selectedPrimitive = undefined;

            return;
        }

        if (this._nearestVertexIndex !== -1) {
            this._selectedPrimitive = this.polyline.getMainVertex(this._nearestVertexIndex);
        } else if (this._nearestEdgeIndex !== -1) {
            this._selectedPrimitive = this.polyline.insertMainVertex(this._nearestEdgeIndex);
        }

        if (this._selectedPrimitive) {
            const scene = this._viewer.scene;

            scene.screenSpaceCameraController.enableRotate = false;
        }
    }

    _onMouseMoveForNoExistSelectedPrimitive(event: MouseEvent) {
        const position = this.getWorldPosition(event.pos, cart3Scratch);

        if (!position) {
            return;
        }

        const polyline = this.polyline;

        polyline.hideMiddleVertices();

        const nearestEdgeIndex = polyline.nearestEdgeIndex(position);
        const nearestVertexIndex = polyline.nearestMainVertexIndex(position);

        this._nearestEdgeIndex = nearestEdgeIndex;
        this._nearestVertexIndex = nearestVertexIndex;

        if (nearestEdgeIndex === -1 && nearestVertexIndex === -1) {
            polyline.setOriginalStyleForAllMainVertices();

            return;
        }

        polyline.setGeneralEditingStyleForAllMainVertices();

        if (nearestVertexIndex !== -1) {
            polyline.setVertexEditingStyleForMainVertex(nearestVertexIndex);
        } else if (nearestEdgeIndex !== -1) {
            polyline.showMiddleVertex(nearestEdgeIndex);
        }
    }

    canvasMoveEvent(event: MouseEvent) {
        if (this._selectedPrimitive) {
            if (event.button === MouseButton.LeftButton) {
                this._onDraggingSelectedPointPrimitive(event);
            }
        } else {
            this._onMouseMoveForNoExistSelectedPrimitive(event);
        }
    }

    private _onDraggingSelectedPointPrimitive(event: MouseEvent) {
        const position = this.getWorldPosition(event.pos, cart3Scratch);

        if (!position) {
            return;
        }

        if (!this._selectedPrimitive) {
            throw new DeveloperError("error");
        }

        const index = this.polyline.indexOfMainVertices(this._selectedPrimitive);

        if (index !== -1) {
            this.polyline.updateMainVertex(index, position);
        }
    }

    canvasReleaseEvent(/* event: MouseEvent */): void {
        this._selectedPrimitive = undefined;

        const scene = this._viewer.scene;

        scene.screenSpaceCameraController.enableRotate = true;
    }

    canvasDoubleClickEvent(event: MouseEvent): void {
        const pickedPrimitive = this.pickPrimitive(event.pos);

        if (!pickedPrimitive) {
            this._selectedPrimitive = undefined;

            return;
        }

        const index = this.polyline.indexOfMainVertices(pickedPrimitive);

        if (index === -1) {
            return;
        }

        this.polyline.removeMainVertex(index);
    }
}
